import { partnersWidget } from '@cred/react-analytics/contexts'
import { logger } from '@cred/fe-logger'

const requiredFields = [
  'source',
  'partnerUrl',
  'partnerReferrer',
  'partnerMeta',
  'widgetGeometry',
  'marketplace',
  'type',
  'variation',
  'credclid',
  'renderId',
]

export const checkIfValidSchema = (analyticsParams) => {
  let isValid = true

  const emptyFields = []

  requiredFields.forEach((key) => {
    const analyticsField = analyticsParams[key]

    const isEmpty = analyticsField === undefined || analyticsField === ''

    if (isEmpty) {
      isValid = false

      emptyFields.push(key)
    }
  })

  if (emptyFields.length > 0) {
    const error = `missed fields: ${emptyFields.join(', ')}`

    logger.error(
      'snowplow_schema_error',
      {
        error,
        analyticsParams,
        routerParams: {
          pathname: window.location.pathname,
          search: window.location.search,
        },
      },
      'Error when initializing partners widget context for snowplow analytics',
    )
  }

  return isValid
}

export const getContexts = ({
  source,
  partnerUrl,
  partnerReferrer,
  variation,
  type,
  marketplace,
  size,
  position,
  credclid,
  renderId,
  contentId,
  articleTitle,
  articleTags,
  segmentId,
  campaignCode,
  contentDistributor,
  contentCategory,
  campaignCodeExt,
}) => {
  const analyticsParams = {
    source,
    partnerUrl,
    partnerReferrer,
    widgetGeometry: { position, size },
    marketplace,
    type,
    variation,
    credclid,
    renderId,
    partnerMeta: {
      contentId,
      articleTitle,
      articleTags,
      segmentId,
      campaignCode,
      contentDistributor,
      contentCategory,
      campaignCodeExt,
    },
  }

  checkIfValidSchema(analyticsParams)
  const spContexts = [partnersWidget.analytics(analyticsParams)]

  return spContexts
}
